const Reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_POSTS":
      return {
        ...state,
        // posts: payload,
        // shownotif: payload,
        // renvoidirect: true,
      };
    case "MSG_vocaux":
      return {
        ...state,
        msgvocaux: payload,
        // shownotif: payload,
        // renvoidirect: true,
      };
    case "SET_Renvoi_direct":
      return {
        ...state,
        // posts: payload,
        //shownotif: payload,
        renvoidirect: true,
      };
    case "SET_Renvoi_interne":
      return {
        ...state,
        // posts: payload,
        // shownotif: payload,
        renvoiinterne: true,
      };
    case "SET_Renvoi_externe":
      return {
        ...state,
        // posts: payload,
        // shownotif: payload,
        renvoiexterne: true,
      };
    case "DEL_Renvoi_direct":
      return {
        ...state,
        // posts: payload,
        //shownotif: payload,
        renvoidirect: false,
      };
    case "DEL_Renvoi_interne":
      return {
        ...state,
        // posts: payload,
        // shownotif: payload,
        renvoiinterne: false,
      };
    case "DEL_Renvoi_externe":
      return {
        ...state,
        // posts: payload,
        // shownotif: payload,
        renvoiexterne: false,
      };
    case "ADD_POST":
      return {
        ...state,
        posts: state.posts.concat(payload),
      };
    case "REMOVE_POST":
      return {
        ...state,
        posts: state.posts.filter((post) => post.id !== payload),
      };
    case "SET_ERROR":
      return {
        ...state,
        error: payload,
      };
    case "SET_SOCKET":
      return {
        ...state,
        socket: payload,
      };
    case "INITIAL_CMK_PHONE":
      return {
        ...state,
        cmkPhone: payload,
      };
    case "MAKE_CALL":
      return {
        ...state,
        makeCall: payload,
      };
    case "IS_CALLING":
      return {
        ...state,
        isCalling: payload,
      };
    case "SET_USER_INFO":
      return {
        ...state,
        userInfo: payload,
      };
    case "SET_REFRESH_CONTENT_JOURNAL":
      return {
        ...state,
        refreshContent: !state.refreshContent,
      };
    default:
      return state;
  }
};

export default Reducer;
